import { useParams } from 'react-router';
import { DevicesPage } from '@/features/mdm-devices/pages/DevicesPage';

/**
 * Thin wrapper: the staff Customer Devices tab just renders the copied MDM
 * DevicesPage bound to the customer's `accountId` from the route.
 *
 * The actual UI lives in `apps/staff/src/features/mdm-devices/` — a hand-synced
 * replica of `apps/web/src/features/mdm-devices/`. When the customer-side UI
 * changes, replay the diff against the staff copy. See
 * `scio3/docs/specs/19-optiedge-mdm/staff-devices-sync.md`.
 */
export function CustomerDevicesPage() {
  const { accountId } = useParams();
  return <DevicesPage accountId={accountId} />;
}
